// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__2_XRq","tab":"UserNav_tab__34k-E"};